import { Collection, } from "@bluelibs/x-ui";
import { ClientRequestRelatedContact } from "@root/api.types";
import { ClientRequestsCollection, ProfilesCollection, AgenciesCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
export class ClientRequestRelatedContactsCollection extends Collection {
    getName() {
        return "ClientRequestRelatedContacts";
    }
    getInputs() {
        return {
            insert: "ClientRequestRelatedContactInsertInput!",
            update: "ClientRequestRelatedContactUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => ClientRequestsCollection,
                name: "clientRequest",
                field: "clientRequestId",
            },
            {
                collection: () => ProfilesCollection,
                name: "profile",
                field: "profileId",
            },
            {
                collection: () => AgenciesCollection,
                name: "agency",
                field: "agencyId",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
